import { Component, OnInit } from '@angular/core';
import { ContactUsComponent } from 'src/app/shared/contact-us/contact-us.component';
import { TermsAndConditionssPageComponent } from 'src/app/shared/terms-and-conditionss-page/terms-and-conditionss-page.component';
import { ServerInfoComponentComponent } from 'src/app/shared/server-info-component/server-info-component.component';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatBottomSheet } from '@angular/material/bottom-sheet'
//import { CookieService } from 'ngx-cookie-service';
// import { environment_state } from 'src/app/config';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  version: any;
  parentRoute  = [];
  year = new Date().getFullYear();
  // public env = environment_state;



  constructor(private dialog: MatDialog
    , private _bottomSheet: MatBottomSheet,
    public router: Router,
    public activatedRoute  : ActivatedRoute) { 

      this.parentRoute = this.activatedRoute['snapshot']['url'];
     }

  ngOnInit() {
    this.version = sessionStorage.getItem('version');

  }
  contactUs(): void {
    const dialogRef = this.dialog.open(ContactUsComponent, { width: '350px', data: '' });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }
  Terms(): void {
    const dialogRef = this.dialog.open(TermsAndConditionssPageComponent, { panelClass: 'min-w-tc', data: '' });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }
  showVersions(): void {
    const data = {
      fd_version: this.version,
      bd_version: JSON.parse(sessionStorage.getItem('server_version'))
    };
    this._bottomSheet.open(ServerInfoComponentComponent, { data });
  }
}
